<template>
  <div
    v-if="sale"
    style="position: relative;">
    <div
      v-if="adv.status==='canceled' || !plan.adv_enabled || !adv.promoteur.plan.adv_enabled"
      class="frontdrop"></div>
    <div class="is-border-top has-background-white is-border-left is-border-right">
      <div class="has-background-white is-padding-left is-padding-right is-padding-top-small is-padding-bottom-small">
        <span class="is-uppercase title is-6">Financement</span>
      </div>
    </div>
    <div
      v-if="!financementCheck"
      class="notification is-warning has-text-centered is-marginless">
      <p
        class="is-uppercase is-size-7 has-text-weight-medium">
        VOUS DEVEZ VÉRIFIER ET/ou COMPLÉTER LES INFORMATIONS MANQUANTES.<br>lES INFORMATIONS MAQUANTES SONT PRÉCÉDÉES DE
        CETTE ICONE <span class="icon has-text-danger is-size-5"><i class="fas fa-check-circle"></i></span> DANS les
        rubriques suivantes
      </p>
    </div>
    <div class="columns is-gapless is-padding-left-small is-minH50p is-marginless-bottom is-border-top is-border-left is-border-right">
      <div class="column is-self-centered is-padding-right">
        <div class="columns">
          <div class="is-padding-top-xsmall is-padding-bottom-xsmall column is-4 is-gapless is-space-between">
            <div
              class="control column is-narrow is-paddingless">
              <input
                class="switch is-success is-rounded"
                id="first_time_buyer"
                type="checkbox"
                name="first_time_buyer"
                @input="$store.commit('modifyCurrentSale', { key: 'funding_data.loans[0].first_time_buyer', value: loans[0].first_time_buyer })"
                v-model="loans[0].first_time_buyer">
              <label
                for="first_time_buyer"
                class="is-uppercase">
                <span
                  class="is-size-6 is-margin-top-xxsmall">Primo-accédant</span>
              </label>
            </div>
          </div>
          <div class="is-padding-top-xsmall is-padding-bottom-xsmall column is-4 is-gapless is-space-between">
            <div
              class="control column is-narrow is-paddingless">
              <input
                class="switch is-success is-rounded"
                id="use_caution"
                type="checkbox"
                name="use_caution"
                @input="$store.commit('modifyCurrentSale', { key: 'funding_data.loans[0].use_caution', value: loans[0].use_caution })"
                v-model="loans[0].use_caution">
              <label
                for="use_caution"
                class="is-uppercase">
                <span
                  class="is-size-6 is-margin-top-xxsmall">Garanti par une caution</span>
              </label>
            </div>
          </div>
          <div class="is-padding-top-xsmall is-padding-bottom-xsmall is-column is-gapless is-space-between is-marginless">
            <div
              class="control column is-narrow is-paddingless">
              <input
                class="switch is-success is-rounded"
                id="use_hypotheque"
                type="checkbox"
                name="use_hypotheque"
                @input="$store.commit('modifyCurrentSale', { key: 'funding_data.loans[0].use_hypotheque', value: loans[0].use_hypotheque })"
                v-model="loans[0].use_hypotheque">
              <label
                for="use_hypotheque"
                class="is-uppercase">
                <span
                  class="is-size-6 is-margin-top-xxsmall">Garanti par une hypothèque</span>
              </label>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div
      class="columns is-12 is-gapless is-padding-left-small is-padding-right-small is-vcentered is-minH50p"
      :class="sale.funding_data.use_loan ? 'is-border-top has-background-light is-border-left is-border-right is-border-bottom is-margin-bottom-xsmall' : 'has-background-dark'">
      <div class="column is-narrow">
        <div class="is-padding-top-xsmall is-padding-bottom-xsmall">
          <div>
            <input
              id="use_loan"
              v-model="useLoan"
              @input="patchUseLoan()"
              name="use_loan"
              class="switch is-success is-rounded"
              type="checkbox">
            <label
              for="use_loan"
              style="font-size: 12.5px"
              :class="sale.funding_data.use_loan ? '' : 'has-text-white'"
              class="is-uppercase">Le réservataire déclare ne pas recourir à un ou plusieurs prêt bancaire</label>
          </div>
        </div>
      </div>
    </div>
    <div v-if="sale && 'funding_data' in sale && 'use_loan' in sale.funding_data && sale.funding_data.use_loan">
      <template v-for="(loan, idx) in loans">
        <loan-item
          :source="loan"
          :multiple-loan="loans.length > 1"
          :index="idx"
          :key="idx"
          @removeLoan="removeLoan"></loan-item>
      </template>
      <div class="row-width-actions-bar">
        <button
          @click="addLoan"
          class="page-header-btn button is-dark is-fullwidth is-radiusless">
          <span>Ajouter une liste de prêt</span>
        </button>
      </div>
    </div>
    <div
      v-if="isAdmin && isPromoteur || currentUser.active_all_contact"
      class="has-background-white is-border-top">
      <div class="row-width-actions-bar columns is-gapless is-marginless">
        <div class="column is-self-centered is-padding-left is-padding-top-xsmall is-padding-bottom-xsmall">
          <span class="is-uppercase title is-6">Commentaire</span>
        </div>
        <div class="column is-narrow is-border-left">
        </div>
      </div>
      <template v-if="openComment">
        <div
          v-if="!openCommentWysi && comment"
          @click="openWysiwyg"
          class="vadDiscussion is-border-top"
          style="cursor: pointer;">
          <div
            class="vadDiscussion--bulle is-size-6 is-minH50p vadDiscussion--bulle--has-actions is-cut is-padding-left">
            <div
              class="content"
              v-if="(isAdmin || currentUser.active_all_contact) && comment"
              v-html="comment"></div>
            <div class="actionsOnRow actionsOnRow--vertical">
              <div class="">
                <button
                  @click="openWysiwyg"
                  class="is-min-height-full">
                  <span class="icon is-small"><i class="fal fa-edit"></i></span>
                </button>
              </div>
            </div>
          </div>
        </div>
        <div
          v-else
          class="is-border-top columns is-gapless">
          <div class="column">
            <wysiwyg-editor
              :light="true"
              :tooltip-top="true"
              :model="comment"
              @change="val => comment = val"
              class="editr--bottom-toolbar no-toolbar editr--height-small content is-borderless">
            </wysiwyg-editor>
          </div>
          <div class="actionsOnRow actionsOnRow--vertical">
            <div>
              <button
                @click="patchComment()"
                type="button"
                class="button"
                :class="[(baseComment !== comment) ? 'is-success' : 'is-info']"
                :disabled="(baseComment === comment)">
                <span class="icon is-small">
                  <i
                    v-if="loadComment"
                    class="fas fa-spinner fa-spin"></i>
                  <i
                    v-else
                    class="fal fa-save"></i>
                </span>
              </button>
            </div>
            <div class="">
              <button
                :disabled="!baseComment"
                type="button"
                :class="{'actionsOnRow-btn--hoverIsDanger': comment}"
                @click="comment?openCommentWysi = false:null; comment = baseComment">
                <span class="icon is-small"><i class="fal fa-times"></i></span>
              </button>
            </div>
          </div>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import { Adv } from '@/mixins'

export default {
  name: 'Financement',
  components: {
    LoanItem: () => import('./LoanItem')
  },
  mixins: [Adv],
  data () {
    return {
      useCaution: false,
      useHypotheque: false
    }
  },
  computed: {
    /**
      * all loans
      * @returns {array}
      */
    loans () {
      return this.sale.funding_data.loans
    },
    /**
      * use loan
      * @returns {boolean}
      */
    useLoan: {
      get: function () {
        return !this.sale.funding_data.use_loan
      },
      set: function (newValue) {
        this.sale.funding_data.use_loan = !newValue
      }
    },
    /**
      * use loan
      * @returns {boolean}
      */
    isCaution: {
      get: function () {
        return !this.sale.funding_data.useCaution
      },
      set: function (newValue) {
        this.sale.funding_data.useCaution = !newValue
      }
    },
    /**
      * financement is complete
      * @returns {boolean}
      */
    financementCheck () {
      if (this.sale && !this.sale.funding_data.use_loan) {
        return true
      } else {
        let loansTrue = []
        this.loans.forEach(loan => {
          if (loan.bank_name !== null && loan.bank_name !== '' &&
              loan.edition_de_l_offre !== null && loan.edition_de_l_offre !== '' &&
              loan.signature_de_l_offre !== null && loan.signature_de_l_offre !== '') loansTrue.push(loan)
        })
        if (loansTrue.length === this.loans.length) {
          return true
        } else {
          return false
        }
      }
    }
  },
  methods: {
    /**
      * patch loan
      */
    patchUseLoan () {
      this.$store.commit('modifyCurrentSale', { key: 'funding_data.use_loan', value: this.useLoan })
    },
    /**
      * remove loan
      */
    removeLoan (index) {
      this.sale.funding_data.loans.splice(index, 1)
      this.$store.commit('modifyCurrentSale', { key: 'funding_data.loans', value: this.loans })
    },
    /**
      * add loan
      */
    addLoan () {
      this.sale.funding_data.loans.push({
        accord_banque: null,
        depot_de_dossier: null,
        bank_name: null,
        edition_de_l_offre: null,
        signature_de_l_offre: null,
        loan_value: null,
        loan_type: null,
        loan_apport: null,
        has_mandat_courtage: false,
        document: null,
        courtier: {
          name: null,
          tel: null,
          email: null
        },
        banking_agency: {
          name: null,
          tel: null,
          email: null
        }
        // validity_date_loan_offer: null,
        // depose_date_loan_offer: null,
        // deposit_paid_to: null,
        // loan_payment_date: null,
        // loan_application_deadline: null
      })
      this.$store.commit('modifyCurrentSale', { key: 'funding_data.loans', value: this.loans })
    }
  }
}
</script>
